import { getApiFunctions } from "store/user/api";

export const generateQRCode = ({ id }, callback) => {
  const functions = getApiFunctions().client.clientDepositBailiffQRGenerate;
  const options = { id };
  functions(options)
    .then((res) => {
      console.log(res);
      const data = res?.data;
      callback && callback({ status: 200, data });
    })
    .catch((err) => {
      console.error(err);
      callback &&
        callback({ status: 500, data: err?.message || "Invalid error" });
    });
};

export const addSupporter = (callback) => {
  const functions = getApiFunctions().manager.addSupporters;
  const id = "gkSntj3RJbhTsOwgkXDCPZaawF42";
  const supporters = ["tl"];
  const options = { id, supporters };
  functions(options)
    .then((res) => {
      console.log(res);
      const data = res?.data;
      callback && callback({ status: 200, data });
    })
    .catch((err) => {
      console.error(err);
      callback &&
        callback({ status: 500, data: err?.message || "Invalid error" });
    });
};
